import { z } from "zod";

/**
 * User HTTP auth — API key provided by the connecting organization.
 * Key is stored in ToolCredentials.apikey, looked up per org at request time.
 * Used by custom API tools where each org brings their own key.
 */
export const CustomManifestUserHttpSchema = z.object({
  type: z.literal("user_http"),
  authorization_type: z.enum(["basic", "bearer", "custom"]).optional(),
  custom_header_name: z.string().optional(),
  custom_header_prefix: z.string().optional()
});

export type CustomManifestUserHttp = z.infer<typeof CustomManifestUserHttpSchema>;
